import recipeListMapping from "../components/recipeListMapping";
import relatedProductsMapping from '../components/relatedProductsMapping';

const searchMapping = (data) => {
    const jsonData = data.data;

    if (!jsonData.length) {
      return {};
    }

    // let components = data.data.relationships.field_components.data;
    // Endpoint Returns two tupes for the grid,
    // field_page_category
    // Recipes, [product and category] results for now

    // Recipes
    const mapRecipePages = data.data.filter((resultEntryPage)=> {
      const isRecipe = resultEntryPage.relationships?.field_page_category?.data.find(keys => keys.name?.[0].value === 'Recipe' )
      return isRecipe
    });

    // Products
    const mapProductPages = data.data.filter((resultEntryPage)=> {
      const isProduct = resultEntryPage.relationships?.field_page_category?.data.find(keys => keys.name?.[0].value === 'Product' )
      return isProduct
    });
    const mappedRecipes = recipeListMapping(mapRecipePages, 'search');
    const mappedProducts = relatedProductsMapping(mapProductPages);

    return {
      foundProducts: mappedProducts,
      foundRecipes: mappedRecipes
    }
};

export default searchMapping;
